export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'uk',
    messages: {
        uk: {
            seo: {
                title: 'BizLite - бізнес блокнот',
                description: 'BizLite – легкий спосіб ведення малого бізнесу',
            },
            app: {
                toolbar: {
                    logout: 'Вийти'
                },
                footer: {
                    contact_us: 'Зв\'язатися з нами'
                }
            },
            nav: {
                logo_title: 'Бізнес-блокнот',
                stats: 'Огляд',
                deal_calendar: 'Календар угод',
                clients: 'Клієнти',
                services: 'Види послуг',
                deals: 'Послуги / угоди',
                timeline: 'Хронологія клієнта',
                staff: 'Співробітники',
                billing: 'Мій кабінет'
            },
            common: {
                description: 'Опис',
                comment: 'Коментар',
                select: 'Вибрати',
                close: 'Закрити',
                cancel: 'Відміна',
                delete: 'Видалити',
                no_data: 'Немає даних',
                yes: 'Так',
                no: 'Ні',
                no_comments: 'Коментарі відсутні ...',
                agreement_read: 'Ознайомитись'
            },
            validation: {
                required_field: 'Обов\'язкове поле',
                required_number: 'Введіть число!',
                required_field_length: 'Мінімальна довжина: {len} символу',
                login_chars: 'Використовуйте лише латинські літери, цифри та символи: . - _',
                email: {
                    incorrect_format: 'Невірний формат e-mail адреси'
                }
            },
            password: {
                current: 'Поточний пароль',
                new: 'Новий пароль',
                repeat: 'Повторіть пароль',
                required_length: 'Мінімальна довжина пароля: {len} символів',
                dont_match: 'Паролі не співпадають!',
                change: 'Змінити пароль',
                msg_changed: 'Пароль успішно змінено',
                error_current_not_match: 'Неправильно вказано поточний пароль',
                error_save: 'Помилка збереження. Спробуйте пізніше'
            },
            profile: {
                personal_data: 'Особисті дані',
                role: {
                    ROLE_MASTER: 'Майстер',
                    ROLE_HIRED: 'Співробітник'
                },
                page_title: 'Профіль користувача',
                email_confirmed: 'E-mail підтверджено',
                email_not_confirmed: 'E-mail не підтверджено',
                form_invalid_msg: 'Не всі дані коректно заповнені',
                change_password: 'Змінити пароль',
                form: {
                    login: 'Логін',
                    name: 'Ім\'я',
                    email: 'E-mail',
                },
                email_confirm: {
                    action: 'Повторне підтвердження e-mail',
                    form_tip: 'Для підтвердження нового e-mail на нього буде надіслано повідомлення',
                    action_block_tip: 'Підтвердження на один e-mail може бути надіслано не частіше одного разу на {minutes} хвилин',
                    success: 'Підтвердження e-mail успішно надіслано. Будь ласка, перевірте пошту',
                    error: 'Помилка надсилання підтвердження. Спробуйте пізніше',
                }
            },
            avatar: {
                change_btn: 'Змінити аватар',
                del_confirm: 'Видалити поточний аватар?'
            },
            register: {
                page_title: 'Реєстрація',
                toolbar_title: 'Реєстрація',
                reg_error: 'Помилка реєстрації. Спробуйте пізніше',
                dup_user_error: 'Користувач із цим логіном вже існує. Виберіть інший логін',
                form: {
                    name: 'Ім\'я',
                    email: 'E-mail',
                    login: 'Логін',
                    password: 'Пароль',
                    password_repeat: 'Повторіть пароль',
                    captcha: {
                        label: 'Введіть відповідь на запитання',
                        hint: 'Ми перевіряємо, що Ви не робот',
                        msg_tries_out: 'Ви використали {tries} спроб. Спробуйте пізніше',
                        msg_wrong_answer: 'Неправильна відповідь! Спробуйте знову'
                    },
                    action: 'Зареєструватися',
                    login_link: 'або УВІЙТИ',
                    email_hint: 'E-mail може використовуватись для важливих повідомлень про роботу сервісу'
                },
                data_processing_hint: 'Я, відповідно до Закону України «Про захист персональних даних», надаю згоду на обробку моїх персональних даних (ПІБ, email) з метою надання послуг, доступу до Сервісу “BizLite — бізнес блокнот” та комунікацій відповідно до Політики конфіденційності. Згода діє протягом усього строку використання Сервісу. Я поінформований(а) про свої права відповідно до законодавства.',
                privacy_agreement: 'Я ознайомлений(а) з Політикою конфіденційності і погоджуюсь на обробку персональних даних'
            },
            email_confirm: {
                page_title: 'E-mail не підтверджено',
                title: 'Ваш e-mail не підтверджено',
                subtitle: 'Вам надіслано листа з посиланням на активацію',
                message: 'Будь ласка, перевірте Вашу електронну скриньку (<b>{email}</b>) та перейдіть за вказаним там посиланням'
            },
            email_confirmed: {
                page_title: 'Підтвердження e-mail',
                title: 'Ваш e-mail підтверджено',
                title_error: 'Помилка підтвердження e-mail',
                subtitle: 'Дякуємо!',
                subtitle_error: 'Сталася помилка!',
                message: 'Ваша e-mail адреса <b>{email}</b> успішно підтверджена і тепер може бути використана Вами для відновлення пароля',
                message_error: 'Не вдалося підтвердити Вашу електронну адресу <b>{email}</b>. Будь ласка, зв\'яжіться з нами',
                login_link: 'Вхід'
            },
            login: {
                page_title: 'Вхід',
                toolbar_title: 'Вхід',
                auth_error: 'Помилка автентифікації. Спробуйте ще раз',
                register_link: 'Реєстрація',
                reset_password_link: 'Забули пароль?',
                form: {
                    login: 'Логін',
                    password: 'Пароль',
                    sign_in: 'Вхід',
                }
            },
            reset_password: {
                title: 'Скидання пароля',
                login: 'Логін',
                email: 'E-mail',
                reset: 'Скинути пароль',
                info_msg: 'Новий пароль буде надіслано на Вашу поштову скриньку',
                success: 'Пароль успішно надіслано на вказаний e-mail',
                error: {
                    user_not_found: 'Помилка! Користувача з таким логіном та e-mail не знайдено',
                    email_not_confirmed: 'Помилка! Цей e-mail не був підтверджений. Будь ласка, зв\'яжіться з нами',
                    general: 'Сталася помилка! Спробуйте пізніше'
                }
            },
            master_select: {
                executor: 'Виконавець',
                my_deals: 'Мої угоди'
            },
            clients: {
                page_title: 'Клієнти',
                toolbar_title: 'База клієнтів',
                create_dlg_title: 'Новий клієнт',
                del_confirm: 'Видалити дані клієнта?',
                form: {
                    name: 'Ім\'я',
                    phones_enter: 'Введіть телефон і натисніть \'Enter\'',
                    phones: 'Телефони',
                    created_at: 'Створено'
                }
            },
            services: {
                page_title: 'Види послуг',
                toolbar_title: 'База послуг',
                create_dlg_title: 'Нова послуга / продукт',
                del_confirm: 'Видалити цю послугу / продукт?',
                form: {
                    name: 'Найменування',
                    price: 'Вартість'
                }
            },
            deals: {
                page_title: 'Послуги / угоди',
                toolbar_title: 'База послуг/угод',
                create_dlg_title: 'Нова угода',
                del_confirm: 'Видалити угоду?',
                change_title: 'Змінити угоду',
                form: {
                    name: 'Назва',
                    client: 'Клієнт',
                    services: 'Послуги',
                    prod_services: 'Продукти / Послуги',
                    price: 'Вартість',
                    total_price: 'Загальна вартість',
                    target_time: 'Дата/час',
                    executor: 'Виконавець',
                    completed: 'Виконано?'
                },
                brief_card: {
                    edit: 'Редагувати угоду',
                    delete: 'Видалити угоду',
                    completed: 'Виконано',
                    del_confirm_msg: 'Видалити угоду?',
                    del_confirm_action: 'Так, видалити',
                    msg_updated: 'Дані успішно оновлені',
                    error_update: 'Помилка збереження даних. Будь ласка, спробуйте пізніше',
                    msg_deleted: 'Угода успішно видалена',
                    error_delete: 'Помилка видалення даних. Будь ласка, спробуйте пізніше'
                }
            },
            staff: {
                page_title: 'Співробітники',
                toolbar_title: 'Співробітники',
                create_dlg_title: 'Додати співробітника',
                del_confirm: 'Видалити співробітника?',
                form: {
                    name: 'Ім\'я',
                    email: 'E-mail',
                    username: 'Логін для входу в систему',
                    password: 'Пароль',
                    change_password: 'Змінити пароль',
                    attention: 'УВАГА!',
                    attention_body: 'Збережіть пароль у безпечному місці'
                },
                column: {
                    username: 'Користувач',
                    created_at: 'Доданий'
                }
            },
            stats: {
                page_title: 'Огляд',
                period: {
                    period: 'Період',
                    current_month: 'Поточний місяць',
                    previous_month: 'Минулий місяць',
                    custom_month: 'Місяць...',
                    current_year: 'Поточний рік',
                    previous_year: 'Минулий рік'
                },
                step: {
                    step: 'Крок',
                    days: 'День',
                    weeks: 'Тиждень',
                    months: 'Місяць',
                    years: 'Рік',
                },
                revenue: {
                    by: 'Прибуток за',
                    step: 'крок',
                    revenue: 'Загальний прибуток',
                    expenses: 'Витрати',
                    profit: 'Чистий прибуток',
                    revenue_by_time: 'Середній прибуток за',
                    revenue_by_client: 'Середній прибуток на клієнта',
                    active_clients: 'Активних клієнтів',
                    axis_revenue: 'Чистий прибуток',
                    by_step_week: 'тиждень',
                    hint_label: 'Сума'
                },
                clients: {
                    revenue_grouped: 'Прибуток від клієнта ({period})',
                    axis_revenue: 'Прибуток',
                    no_revenue: 'Доходи відсутні',
                    expense_grouped: 'Витрати по групах ({period})',
                    axis_expense: 'Витрати',
                    no_expense: 'Витрати відсутні',
                    annot_revenue_by: 'Клієнт',
                    annot_expense_by: 'Тип витрат'
                }
            },
            deal_calendar: {
                page_title: 'Календар угод',
                nav: {
                    previous: 'Попередній',
                    next: 'Наступний'
                },
                create_hint: '❃ Натисніть на дату, щоб створити угоду'
            },
            timeline: {
                page_title: 'Хронологія клієнта',
                created_title: 'Клієнта додано'
            },
            billing: {
                page_title: 'Мій кабінет',
                tabs: {
                    general: {
                        title: 'Тарифний план'
                    },
                    payments: {
                        title: 'Мої платежі',
                        toolbar_title: 'Платежі'
                    }
                },
                access_until: 'Дійсний до',
                btn: {
                    change_plan: 'Змінити',
                    prolong: 'Подовжити'
                },
                tariff_plan: {
                    type: {
                        BASIC: 'Базовий',
                        EMPLOYER: 'Роботодавець',
                        UNLIM: 'Безліміт'
                    },
                    summary: 'Про тарифні плани',
                    current: 'Тарифний план',
                    period_short: 'міс.',
                    discount: 'знижка',
                    description: {
                        BASIC: 'Доступний <u>весь функціонал</u> сервісу, <b><u>за винятком</u> можливості керування співробітниками</b> (список співробітників, вхід співробітника до системи, створення угод від імені співробітника, статистика з окремих співробітників)',
                        EMPLOYER: 'Доступний <u>весь функціонал</u> сервісу, <b><u>включаючи</u> можливість керування співробітниками</b>. Кількість співробітників не обмежена'
                    },
                    hint: '↓ Див. інформацію про тарифні плани ↓<br/><b>** Перший місяць безкоштовно!</b>',
                    change: {
                        title: 'Зміна тарифного плану',
                        label: 'Виберіть новий тарифний план',
                        action: 'Змінити план',
                        date_recalculate_hint: '<b>Перерахунок тарифу</b>: новий план діятиме до <span class="bg-blue-grey-1 text-teal text-weight-bold">{date}</span>',
                        success: 'Тарифний план успішно змінено',
                        error: 'Помилка зміни тарифного плану. Спробуйте пізніше',
                        re_login: {
                            title: 'Увійти заново',
                            description: 'Тарифний план успішно змінено. Потрібен повторний вхід',
                        }
                    },
                    is_expired: '* Термін дії поточного пакета минув',
                    is_expired_short: 'Термін дії минув'
                },
                payments: {
                    created_at: 'Створено',
                    tx_time: 'Час транзакції',
                    total: 'Сума',
                    status: {
                        title: 'Статус',
                        CREATED: 'Ініційований',
                        SUCCESS: 'Успішний',
                        ERROR: 'Помилка'
                    },
                    tariff_plan: 'Тарифний план',
                    tariff_period: 'Період оплати, міс',
                    tx_id: 'ID транзакції',
                    payer_name: 'Платник',
                },
                prolong: {
                    title: 'Подовження пакету послуг',
                    action: 'Оплатити',
                    payment_redirect: 'Перенаправлення в платіжну систему...',
                    error: 'Помилка подовження пакету. Спробуйте пізніше',
                    period: {
                        label: 'Виберіть період подовження, місяців'
                    },
                    payment_price: '* Вартість подовження послуги: <b><u>${price}</u></b>',
                    discount: ' (Знижка {discount}%)',
                    until_hint: '* Пакет послуг діятиме до <b><u>{until}</u></b>',
                    drop_trial_hint: 'Увага! Ця дія перерве безкоштовний період використання сервісу!',
                    agreement: 'Я погоджуюсь з умовами Угоди Користувача',
                },
                ps_response: {
                    page_title: 'Відповідь платіжної системи',
                    title: {
                        loading_error: 'Не вдалося отримати статус платежу',
                        error: 'Не вдалося здійснити платіж',
                        success: 'Платіж успішно оброблений',
                    },
                    body: {
                        loading_error: 'Не вдалося отримати статус платежу. Перейдіть на вкладку «Платежі»',
                        error: 'Не вдалося здійснити платіж. Статус: «{status}»',
                        success: 'Платіж успішно оброблений! Зміни набудуть чинності за наступного входу в систему',
                    },
                    re_login: 'Увійти заново'
                }
            },
            tariff_inactive: {
                page_title: 'Тарифний план неактивний',
                card: {
                    title: 'Тарифний план неактивний',
                    subtitle: 'На даний момент тариф Вашої організації неактивний. Частина дій недоступна',
                }
            },
            crud: {
                main: {
                    tab_general: 'Загальне',
                    search: 'Пошук'
                },
                table: {
                    no_data: 'Дані відсутні',
                    filter: 'Фільтр...'
                },
                create: {
                    save: 'Зберегти',
                    cancel: 'Відміна',
                    add: 'Додати',
                    new_object: 'Новий об\'єкт',
                    msg_data_added: 'Дані додані',
                    save_error: 'Помилка збереження даних. Будь ласка, спробуйте пізніше!'
                },
                details: {
                    change: 'Змінити',
                    save: 'Зберегти',
                    cancel: 'Відміна',
                    delete: 'Видалити',
                    del_confirm: 'Так, видалити',
                    del_confirm_default: 'Ви впевнені? Видалення даних є незворотним!',
                    msg_data_updated: 'Дані успішно оновлені',
                    msg_data_deleted: 'Дані успішно видалені',
                    del_error_integrity: 'Об\'єкт зараз не може бути видалений, бо він пов\'язаний з іншими даними',
                    del_error: 'Помилка видалення даних. Будь ласка, спробуйте пізніше!',
                    save_error: 'Помилка збереження даних. Будь ласка, спробуйте пізніше!'
                }
            }
        },

        ru: {
            seo: {
                title: 'BizLite - бизнес блокнот',
                description: 'BizLite - легкий способ ведения малого бизнеса',
            },
            app: {
                toolbar: {
                    logout: 'Выйти'
                },
                footer: {
                    contact_us: 'Связаться с нами'
                }
            },
            nav: {
                logo_title: 'Бизнес-блокнот',
                stats: 'Обзор',
                deal_calendar: 'Календарь сделок',
                clients: 'Клиенты',
                services: 'Виды услуг',
                deals: 'Услуги / сделки',
                timeline: 'Хронология клиента',
                staff: 'Сотрудники',
                billing: 'Мой кабинет'
            },
            common: {
                description: 'Описание',
                comment: 'Коментарий',
                select: 'Выбрать',
                close: 'Закрыть',
                cancel: 'Отмена',
                delete: 'Удалить',
                no_data: 'Нет данных',
                yes: 'Да',
                no: 'Нет',
                no_comments: 'Коментарии отсутствуют ...',
                agreement_read: 'Ознакомиться'
            },
            validation: {
                required_field: 'Обязательное поле',
                required_number: 'Введите число!',
                required_field_length: 'Минимальная длина: {len} символа',
                login_chars: 'Используйте только латинские буквы, цифры и символы: . - _',
                email: {
                    incorrect_format: 'Неверный формат e-mail адреса',
                }
            },
            password: {
                current: 'Текущий пароль',
                new: 'Новый пароль',
                repeat: 'Повторите пароль',
                required_length: 'Минимальная длина пароля: {len} символов',
                dont_match: 'Пароли не совпадают!',
                change: 'Сменить пароль',
                msg_changed: 'Пароль успешно изменен',
                error_current_not_match: 'Неправильно указан текущий пароль',
                error_save: 'Ошибка сохранения. Попробуйте позже'
            },
            profile: {
                personal_data: 'Личные данные',
                role: {
                    ROLE_MASTER: 'Мастер',
                    ROLE_HIRED: 'Сотрудник'
                },
                page_title: 'Профиль пользователя',
                email_confirmed: 'E-mail подтвержден',
                email_not_confirmed: 'E-mail не подтвержден',
                form_invalid_msg: 'Не все данные корректно заполнены',
                change_password: 'Сменить пароль',
                form: {
                    login: 'Логин',
                    name: 'Имя',
                    email: 'E-mail',
                },
                email_confirm: {
                    action: 'Повторное подтверждение e-mail',
                    form_tip: 'Для подтверждения нового e-mail на него будет выслано сообщение',
                    action_block_tip: 'Подтверждение на один e-mail может быть отослано не чаще одного раза в {minutes} минут',
                    success: 'Подтверждение e-mail успешно выслано. Пожалуйста, проверьте почту',
                    error: 'Ошибка отсылки подтверждения. Попробуйте позже',
                }
            },
            avatar: {
                change_btn: 'Изменить аватар',
                del_confirm: 'Удалить текущий аватар?'
            },
            register: {
                page_title: 'Регистрация',
                toolbar_title: 'Регистрация',
                reg_error: 'Ошибка регистрации. Попробуйте позже',
                dup_user_error: 'Пользователь с данным логином уже существует. Выберите другой логин',
                form: {
                    name: 'Имя',
                    email: 'E-mail',
                    login: 'Логин',
                    password: 'Пароль',
                    password_repeat: 'Повторите пароль',
                    captcha: {
                        label: 'Введите ответ на вопрос',
                        hint: 'Мы проверяем, что Вы не робот',
                        msg_tries_out: 'Вы использовали {tries} попыток. Попробуйте позже',
                        msg_wrong_answer: 'Неверный ответ! Попробуйте снова'
                    },
                    action: 'Зарегистрироваться',
                    login_link: 'или ВОЙТИ',
                    email_hint: 'E-mail может использоваться для важных уведомлений о работе сервиса'
                },
                data_processing_hint: 'Я, в соответствии с Законом Украины «О защите персональных данных», соглашаюсь на обработку моих персональных данных (ФИО, email) с целью предоставления услуг, доступа к Сервису “BizLite — бизнес блокнот” и коммуникациям в соответствии с Политикой конфиденциальности. Согласие действует в течение всего срока использования Сервиса. Я проинформирован(а) о своих правах в соответствии с законодательством.',
                privacy_agreement: 'Я ознакомлен(а) с Политикой конфиденциальности и соглашаюсь на обработку персональных данных'
            },
            email_confirm: {
                page_title: 'E-mail не подтвержден',
                title: 'Ваш e-mail не подтвержден',
                subtitle: 'Вам выслано письмо со ссылкой на активацию',
                message: 'Пожалуйста, проверьте Ваш электронный ящик (<b>{email}</b>) и перейдите по указанной там ссылке'
            },
            email_confirmed: {
                page_title: 'Подтверждение e-mail',
                title: 'Ваш e-mail подтвержден',
                title_error: 'Ошибка подтверждения e-mail',
                subtitle: 'Спасибо!',
                subtitle_error: 'Произошла ошибка!',
                message: 'Ваш e-mail адрес <b>{email}</b> успешно подтвержден и теперь может быть использован Вами для восстановления пароля',
                message_error: 'Не удалось подтвердить Ваш e-mail адрес <b>{email}</b>. Пожалуйста, свяжитесь с нами',
                login_link: 'Вход'
            },
            login: {
                page_title: 'Вход',
                toolbar_title: 'Вход',
                auth_error: 'Ошибка аутентификации. Попробуйте еще раз',
                register_link: 'Регистрация',
                reset_password_link: 'Забыли пароль?',
                form: {
                    login: 'Логин',
                    password: 'Пароль',
                    sign_in: 'Вход',
                }
            },
            reset_password: {
                title: 'Сброс пароля',
                login: 'Логин',
                email: 'E-mail',
                reset: 'Сбросить пароль',
                info_msg: 'Новый пароль будет выслан на Ваш почтовый ящик',
                success: 'Пароль успешно выслан на указанный e-mail',
                error: {
                    user_not_found: 'Ошибка! Пользователь с таким логином и e-mail не найден',
                    email_not_confirmed: 'Ошибка! Данный e-mail не был подтвержден. Пожалуйста, свяжитесь с нами',
                    general: 'Произошла ошибка! Попробуйте позже'
                }
            },
            master_select: {
                executor: 'Исполнитель',
                my_deals: 'Мои сделки'
            },
            clients: {
                page_title: 'Клиенты',
                toolbar_title: 'База клиентов',
                create_dlg_title: 'Новый клиент',
                del_confirm: 'Удалить данные клиента?',
                form: {
                    name: 'Имя',
                    phones_enter: 'Введите телефон и нажмите \'Enter\'',
                    phones: 'Телефоны',
                    created_at: 'Создан'
                }
            },
            services: {
                page_title: 'Виды услуг',
                toolbar_title: 'База услуг',
                create_dlg_title: 'Новая услуга / продукт',
                del_confirm: 'Удалить эту услугу / продукт?',
                form: {
                    name: 'Наименование',
                    price: 'Стоимость'
                }
            },
            deals: {
                page_title: 'Услуги / сделки',
                toolbar_title: 'База услуг/сделок',
                create_dlg_title: 'Новая сделка',
                del_confirm: 'Удалить сделку?',
                change_title: 'Изменить сделку',
                form: {
                    name: 'Название',
                    client: 'Клиент',
                    services: 'Услуги',
                    prod_services: 'Продукты / Услуги',
                    price: 'Стоимость',
                    total_price: 'Общая стоимость',
                    target_time: 'Дата/время',
                    executor: 'Исполнитель',
                    completed: 'Выполнено?'
                },
                brief_card: {
                    edit: 'Редактировать сделку',
                    delete: 'Удалить сделку',
                    completed: 'Выполнено',
                    del_confirm_msg: 'Удалить сделку?',
                    del_confirm_action: 'Да, удалить',
                    msg_updated: 'Данные успешно обновлены',
                    error_update: 'Ошибка сохранения данных. Пожалуйста, попробуйте позже',
                    msg_deleted: 'Сделка успешно удалена',
                    error_delete: 'Ошибка удаления данных. Пожалуйста, попробуйте позже'
                }
            },
            staff: {
                page_title: 'Сотрудники',
                toolbar_title: 'Сотрудники',
                create_dlg_title: 'Добавить сотрудника',
                del_confirm: 'Удалить сотрудника?',
                form: {
                    name: 'Имя',
                    email: 'E-mail',
                    username: 'Логин для входа в систему',
                    password: 'Пароль',
                    change_password: 'Сменить пароль',
                    attention: 'ВНИМАНИЕ!',
                    attention_body: 'Сохраните пароль в безопасном месте'
                },
                column: {
                    username: 'Пользователь',
                    created_at: 'Добавлен'
                }
            },
            stats: {
                page_title: 'Обзор',
                period: {
                    period: 'Период',
                    current_month: 'Текущий месяц',
                    previous_month: 'Прошлый месяц',
                    custom_month: 'Месяц ...',
                    current_year: 'Текущий год',
                    previous_year: 'Прошлый год'
                },
                step: {
                    step: 'Шаг',
                    days: 'День',
                    weeks: 'Неделя',
                    months: 'Месяц',
                    years: 'Год',
                },
                revenue: {
                    by: 'Доходы за',
                    step: 'шаг',
                    revenue: 'Общий доход',
                    expenses: 'Расходы',
                    profit: 'Чистая прибыль',
                    revenue_by_time: 'Средний доход в',
                    revenue_by_client: 'Средний доход на клиента',
                    active_clients: 'Активных клиентов',
                    axis_revenue: 'Чистая прибыль',
                    by_step_week: 'неделю',
                    hint_label: 'Сумма'
                },
                clients: {
                    revenue_grouped: 'Доход от клиента ({period})',
                    axis_revenue: 'Доход',
                    no_revenue: 'Доходы отсутствуют',
                    expense_grouped: 'Расход по группам ({period})',
                    axis_expense: 'Расход',
                    no_expense: 'Расходы отсутствуют',
                    annot_revenue_by: 'Клиент',
                    annot_expense_by: 'Тип расхода'
                }
            },
            deal_calendar: {
                page_title: 'Календарь сделок',
                nav: {
                    previous: 'Предыдущий',
                    next: 'Следующий'
                },
                create_hint: '❃ Нажмите на дату, чтобы создать сделку'
            },
            timeline: {
                page_title: 'Хронология клиента',
                created_title: 'Клиент добавлен'
            },
            billing: {
                page_title: 'Мой кабинет',
                tabs: {
                    general: {
                        title: 'Тарифный план'
                    },
                    payments: {
                        title: 'Мои платежи',
                        toolbar_title: 'Платежи'
                    }
                },
                access_until: 'Действителен до',
                btn: {
                    change_plan: 'Сменить',
                    prolong: 'Продлить'
                },
                tariff_plan: {
                    type: {
                        BASIC: 'Базовый',
                        EMPLOYER: 'Работодатель',
                        UNLIM: 'Безлимит'
                    },
                    summary: 'О тарифных планах',
                    current: 'Тарифный план',
                    period_short: 'мес.',
                    discount: 'скидка',
                    description: {
                        BASIC: 'Доступен <u>весь функционал</u> сервиса, <b><u>за исключением</u> возможности управления сотрудниками</b> (список сотрудников, вход сотрудника в систему, создание сделок от имени сотрудника, статистика по отдельным сотрудникам)',
                        EMPLOYER: 'Доступен <u>весь функционал</u> сервиса, <b><u>включая</u> возможность управления сотрудниками</b>. Количество сотрудников не ограничено'
                    },
                    hint: '↓ См. информацию о тарифных планах ↓<br/><b>** Первый месяц бесплатно!</b>',
                    change: {
                        title: 'Смена тарифного плана',
                        label: 'Выберите новый тарифный план',
                        action: 'Сменить план',
                        date_recalculate_hint: '<b>Пересчёт тарифа</b>: новый план будет действовать до <span class="bg-blue-grey-1 text-teal text-weight-bold">{date}</span>',
                        success: 'Тарифный план успешно изменён',
                        error: 'Ошибка смены тарифного плана. Попробуйте позже',
                        re_login: {
                            title: 'Войти заново',
                            description: 'Тарифный план успешно изменён. Требуется повторный вход'
                        }
                    },
                    is_expired: '* Срок действия текущего пакета истек',
                    is_expired_short: 'Срок действия истек'
                },
                payments: {
                    created_at: 'Создан',
                    tx_time: 'Время транзакции',
                    total: 'Сумма',
                    status: {
                        title: 'Статус',
                        CREATED: 'Инициирован',
                        SUCCESS: 'Успешный',
                        ERROR: 'Ошибка'
                    },
                    tariff_plan: 'Тарифный план',
                    tariff_period: 'Период оплаты, мес',
                    tx_id: 'ID транзакции',
                    payer_name: 'Плательщик',
                },
                prolong: {
                    title: 'Продление пакета услуг',
                    action: 'Оплатить',
                    payment_redirect: 'Перенаправление в платежную систему ...',
                    error: 'Ошибка продления пакета. Попробуйте позже',
                    period: {
                        label: 'Выберите период продления, месяцев'
                    },
                    payment_price: '* Стоимость продления услуги: <b><u>${price}</u></b>',
                    discount: ' (Скидка {discount}%)',
                    until_hint: '* Пакет услуг будет действовать до <b><u>{until}</u></b>',
                    drop_trial_hint: 'Внимание! Это действие прервет бесплатный период использования сервиса!',
                    agreement: 'Я соглашаюсь с условиями Пользовательского Соглашения',
                },
                ps_response: {
                    page_title: 'Ответ платежной системы',
                    title: {
                        loading_error: 'Не удалось получить статус платежа',
                        error: 'Не удалось совершить платеж',
                        success: 'Платеж успешно обработан',
                    },
                    body: {
                        loading_error: 'Не удалось получить статус платежа. Перейдите на вкладку «Платежи»',
                        error: 'Не удалось совершить платеж. Статус: «{status}»',
                        success: 'Платеж успешно обработан! Изменения вступят в силу при следующем входе в систему',
                    },
                    re_login: 'Войти заново'
                }
            },
            tariff_inactive: {
                page_title: 'Тарифный план неактивен',
                card: {
                    title: 'Тарифный план неактивен',
                    subtitle: 'В данный момент тариф Вашей организации неактивен. Часть действий недоступна',
                }
            },
            crud: {
                main: {
                    tab_general: 'Общее',
                    search: 'Поиск'
                },
                table: {
                    no_data: 'Данные отсутствуют',
                    filter: 'Фильтр ...'
                },
                create: {
                    save: 'Сохранить',
                    cancel: 'Отмена',
                    add: 'Добавить',
                    new_object: 'Новый объект',
                    msg_data_added: 'Данные добавлены',
                    save_error: 'Ошибка сохранения данных. Пожалуйста, попробуйте позже!'
                },
                details: {
                    change: 'Изменить',
                    save: 'Сохранить',
                    cancel: 'Отмена',
                    delete: 'Удалить',
                    del_confirm: 'Да, удалить',
                    del_confirm_default: 'Вы уверены? Удаление данных необратимо!',
                    msg_data_updated: 'Данные успешно обновлены',
                    msg_data_deleted: 'Данные успешно удалены',
                    del_error_integrity: 'Объект сейчас не может быть удален, т.к. связан с другими Вашими данными',
                    del_error: 'Ошибка удаления данных. Пожалуйста, попробуйте позже!',
                    save_error: 'Ошибка сохранения данных. Пожалуйста, попробуйте позже!'
                }
            }
        }
    }
}))